import React from "react";
import parse from "html-react-parser";

function AdPixel({ props }) {
  const manyChatPixel = props ? parse(props.manychat_pixel)  : "";
  const onesignalPixel = props ? parse(props.onesignal_pixel) : "";
  const retargetingPixel = props ? parse(props.retargeting_pixel) : "";
  const sumoPixel = props ? parse(props.sumo_pixel) : "";
  return (
    <>
      {manyChatPixel}
      {onesignalPixel}
      {retargetingPixel}
      {sumoPixel}
    </>
  );
}

export default AdPixel;
